import styled from 'styled-components';

export const StyledMeta = styled.button`
  background-color: transparent;
  padding: ${(p) => p.theme.space[0]};
  margin-top: auto;
  border-radius: ${(p) => p.theme.radii.pill};

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusAlt};
  }
`;
